import styled from "styled-components";

export const EditTournamentPrizeWrapper = styled.div`
  display: flex;
  position: relative;
  gap: 20px;

  .overlay {
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgb(255, 255, 255);
    padding: 5px;
    position: absolute;
    top: 0-3px;
    left: -5px;
    width: 100%;
    height: calc(100% - 4px);
    border-radius: 6.744px;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1;
  }
`;

export const EditTournamentPrizeBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  > .title {
    display: flex;
    gap: 30px;
    position: relative;
    align-items: center;

    > .name {
      font-family: Pretendard;
      font-weight: 600;
      font-size: 20px;
      width: 169px;
      color: #121212;
    }
  }
`;

export const EditTournamentPrizeSettingItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;

  > .name {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 15px;
    width: 40px;
  }
`;

export const EditTournamentPrizeInput = styled.div`
  position: relative;

  > input {
    width: 150px;
    height: 28px;
    border-radius: 2.7px;
    box-sizing: border-box;
    padding: 5px 8px;
    border: 0.67px solid var(--Black-200, #b7b7b7);
    outline: none;
    font-family: Pretendard;
    font-weight: 500;
    font-size: 10.79px;

    &.daily {
      width: 48px;
    }
  }

  > span {
    font-family: Pretendard;
    font-weight: 500;
    font-size: 10.79px;
    position: absolute;
    top: 8px;
    right: 5px;
  }
`;

export const EditTournamentPrizeSettingWrapper = styled.div`
  margin-left: 194px;
  margin-top: 7px;
  background: #f0f0f0;
  padding: 15px;
  border-radius: 8px;
  width: max-content;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  max-height: 289px;
  overflow: auto;
  scrollbar-width: none;
`;

export const EditTournamentPrizeInfoWrapper = styled.div`
  margin-top: 110px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  > .wrapper {
    display: flex;
    gap: 18px;

    > .can {
      font-family: Pretendard;
      font-weight: 500;
      font-size: 14px;
      display: flex;
      gap: 10px;

      > span {
        font-weight: 600;
      }
    }
  }
`;

export const EditTournamentPrizeInfoSettingHeader = styled.div`
  display: flex;
  height: 28px;
  align-items: center;
  gap: 10px;
  font-family: Pretendard;
  font-weight: 600;
  font-size: 17px;

  > .rate {
    margin-left: 10px;
    font-size: 14px;
  }

  span {
    top: 9px;
  }
`;

export const EditTournamentPrizeInfoSettingWrapper = styled.div`
  background: #f0f0f0;
  padding: 15px;
  border-radius: 8px;
  width: max-content;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  max-height: 289px;
  overflow: auto;
  scrollbar-width: none;
`;

export const EditTournamentPrizeDiscount = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 14px;
`;
